import { useEffect, useState } from "react";
import { TableLadles } from "./components/DataTable/TableLadles";
import { useLadleHMContext } from "./context/LadleHeatMetricContext";
import { getLadles } from "./repositories/LadleHMRepository";

export const LadleHeatMetricsPage = () => {
	const { state, actions } = useLadleHMContext();
	const [isLoading, setIsLoading] = useState(true);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getLadlesFromAPI = async () => {
		setIsLoading(true);
		try {
			const { ladles, ok } = await getLadles();
			if (ok) {
				actions.setLadles(ladles);
				setIsLoading(false);
			}
		} catch (error) {
			setFetchDataError(error as string);
			setShowErrorModal(true);
		}
	};

	useEffect(() => {
		getLadlesFromAPI();
	}, []);
	return (
		<div>
			<TableLadles isLoading={isLoading} getLadlesFromAPI={getLadlesFromAPI} />
		</div>
	);
};
